/* eslint-disable no-param-reassign */
import qs from 'qs'
import { useUserStore } from '/@/store/modules/user'

// 请求基准地址
const baseUrl = import.meta.env.VITE_APP_BASE_URL

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: any) {
    // 接口请求支持通过 params 参数配置 paramsString
    if (options.params) {
      const paramsStr = qs.stringify(options.params)
      if (options.url.includes('?')) {
        options.url += `&${paramsStr}`
      } else {
        options.url += `?${paramsStr}`
      }
    }
    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      options.url = baseUrl + options.url
    }
    // 1. 请求超时
    options.timeout = options.timeout || 5000 // 5s
    // 2. 请求头标识
    const { token } = useUserStore()
    options.header = {
      ...options.header,
      'Content-Type': 'application/json',
    }
    if (token){
      options.header['Authorization'] = `JWT ${token}`
    }
  },
}

export const requestInterceptor = {
  install() {
    // 拦截所有请求类型（包括OPTIONS）
    uni.addInterceptor('request', {
      ...httpInterceptor,
    })
  },
}
